module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7135/js/img/MarketingHub_Icon.svg"